const MAX_LENGTH = 512
const ELLIPSIS = '...'
export const EM_DASH = '—'

/* C0/C1 controls, zero-width and bidi format marks, line/paragraph separators, BOM. */
const isStrippableChar = (code: number): boolean =>
  code < 32 ||
  (code >= 127 && code <= 159) ||
  (code >= 8203 && code <= 8207) ||
  code === 8232 ||
  code === 8233 ||
  code === 8288 ||
  code === 65279

const stripControlChars = (text: string): string => {
  let out = ''

  for (const char of text) {
    if (!isStrippableChar(char.codePointAt(0) ?? 0)) out += char
  }

  return out
}

/**
 * Asset values originate in customer environments and third-party products, so they are
 * untrusted. Applied where responses are mapped into models, not at each render site.
 */
export const sanitizeAssetValue = (value: unknown): string | null => {
  if (value === null || value === undefined || value === '') return null

  const text = typeof value === 'string' ? value : String(value)
  const stripped = stripControlChars(text).trim()

  if (!stripped) return null

  return stripped.length > MAX_LENGTH ? `${stripped.slice(0, MAX_LENGTH)}${ELLIPSIS}` : stripped
}

/* Chart axis labels get a tighter clamp - long strings break the plot area rather than the page. */
export const sanitizeChartLabel = (value: unknown, maxLength = 24): string => {
  const text = sanitizeAssetValue(value)

  if (!text) return EM_DASH

  return text.length > maxLength ? `${text.slice(0, maxLength)}${ELLIPSIS}` : text
}
